function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.985 2.671A1.237 1.237 0 013.221 1.5h.637a1.237 1.237 0 011.235 1.171l.461 8.525A1.238 1.238 0 014.32 12.5H2.76a1.238 1.238 0 01-1.235-1.304l.46-8.525zM5.61 12.5h5.63a1.237 1.237 0 001.238-1.238V3.7a.413.413 0 00-.692-.303l-2.882 2.66V3.7a.413.413 0 00-.693-.303l-2.406 2.22.3 5.55c.027.515-.165.99-.495 1.333zm1.918-3.3a.55.55 0 01.55-.55h2.2a.55.55 0 01.55.55v2.475h-3.3V9.2z",
  fill: "currentColor"
});

var SvgProduction = function SvgProduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgProduction;